import currency from './currency'
import datetime from './datetime'
import dateShort from './date-short'
import dateLong from './date-long'
import homg_percentage from './percentage'

export default {
    currency,
    datetime,
    dateShort,
    dateLong,
    homg_percentage
}


// WEBPACK FOOTER //
// ./src/formatters/formatters.js